import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';
import { useNosIdQuery } from '@/hooks/api/base.hooks';

export const usersQueryOptions = queryOptions({
  queryKey: ['users'],
  queryFn: () => api.get('/api/v1/users'),
});

export function useGetUsers() {
  return useNosIdQuery(usersQueryOptions);
}
